module.exports = __webpack_public_path__ + "img/ignition-off.37aa7ec2.svg";